<template>
  <div @click="onClick" class="custom-accordion-item text-truncate py-1">
    {{ addressString }}
  </div>
</template>

<script>
import { AddressHelper } from '@/helpers/AddressHelper'

export default {
  name: 'ClientAddressFieldLookupResult',
  props: {
    address: Object
  },
  computed: {
    addressString () {
      return AddressHelper.getAddressLines(this.address).join(', ')
    }
  },
  methods: {
    onClick () {
      this.$emit('addressClicked', this.address)
    }
  }
}
</script>
